import styled from 'styled-components';
import { breakpoints } from '../styles/breakpoints';
import { ERROR as COLOR_ERROR, FADE_WHITE, FADE_WHITE_FOCUS } from '../styles/colors';
import { textSecurity } from '../styles/textSecurity';
import { PIN_PATTERN } from '../config/constants';
import { getColorForInputState, InputState } from './InputState';

type InputProps = {
	state?: InputState;
	center?: boolean;
};

export const Input = styled.input<InputProps>`
	display: block;
	width: 100%;
	background: ${FADE_WHITE};
	transition: background 0.2s ease-in, border-color 0.2s ease-in;
	color: #fff;
	appearance: none;
	font-size: 18px;
	padding: 14px 20px;
	border: 1px solid ${(props) => getColorForInputState(props.state)};
	border-radius: 6px;
	line-height: 1.2;
	text-align: ${(props) => (props.center ? 'center' : 'left')};

	&:focus {
		outline: none;
		background: ${FADE_WHITE_FOCUS};
	}

	&::placeholder {
		color: ${(props) => (props.state === InputState.ERROR ? COLOR_ERROR : '#fff')};
	}

	&[disabled] {
		color: #999;
	}

	@media ${breakpoints.sm} {
		font-size: 20px;
	}

	@media ${breakpoints.md} {
		font-size: 22px;
	}
`;

Input.defaultProps = {
	state: InputState.NORMAL,
	autoCapitalize: 'false',
	autoCorrect: 'false',
};

export const InputLarge = styled(Input)`
	border-width: 2px;
	font-size: 32px;

	@media ${breakpoints.sm} {
		font-size: 36px;
	}

	@media ${breakpoints.md} {
		font-size: 40px;
	}
`;

export const InputPin = styled(Input)`
	${textSecurity};
`;

InputPin.defaultProps = {
	type: 'text',
	inputMode: 'numeric',
	pattern: PIN_PATTERN,
	autoComplete: 'off',
	maxLength: 4,
};
